import _ from 'lodash'
import domtoimage from 'dom-to-image'

const rootContainerId = 'widget-container'
export const iconButton = 'exportIconButton'
const ANIMATIONS = Symbol('animation')
const filter = (node) => node.id !== iconButton

export function exportToCsv(filename, rows, valueSeparator = 'comma') {
  if (!String(filename).endsWith('.csv')) {
    filename += '.csv'
  }
  let separator = ','
  if (valueSeparator == 'semicolon') {
    separator = ';'
  } else if (valueSeparator == 'tab') {
    separator = '\t'
  }
  var processRow = function (row) {
    var finalVal = ''
    for (var j = 0; j < row.length; j++) {
      var innerValue = row[j] === null ? '' : _.get(row, [j], '')
      if (row[j] instanceof Date) {
        innerValue = row[j].toLocaleString()
      }
      let result = formatCSVValue(innerValue)
      if (!navigator.msSaveBlob) {
        result = encodeURIComponent(result)
      }
      if (j > 0) {
        finalVal += separator
      }
      finalVal += result
    }
    return finalVal + '\n'
  }

  var csvFile = '\ufeff'
  for (var i = 0; i < rows.length; i++) {
    csvFile += processRow(rows[i])
  }
  var decodedCsv = decodeURIComponent(csvFile)
  var blob = new Blob([decodedCsv], { type: 'text/csv;charset=utf-8;\ufeff' })
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, filename)
  } else {
    var link = document.createElement('a')
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      // var url = 'data:text/csv;charset=utf-8,\ufeff' + URL.createObjectURL(blob);
      link.setAttribute('href', URL.createObjectURL(blob))
      link.setAttribute('download', filename)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}

const parseCSVRow = (csvRow) => {
  const fields = []
  let currentField = ''
  let insideQuotes = false

  for (let i = 0; i < csvRow.length; i++) {
    const char = csvRow[i]
    const nextChar = csvRow[i + 1]

    if (char === '"' && insideQuotes && nextChar === '"') {
      currentField += '"'
      i++
    } else if (char === '"') {
      insideQuotes = !insideQuotes
    } else if (char === ',' && !insideQuotes) {
      fields.push(currentField)
      currentField = ''
    } else {
      currentField += char
    }
  }

  fields.push(currentField)
  return fields
}

export const parseCSV = (csvText) => {
  const rows = []
  let currentRow = ''
  let insideQuotes = false

  try {
    for (let i = 0; i < csvText.length; i++) {
      const char = csvText[i]

      if (char === '"') {
        insideQuotes = !insideQuotes
      }

      if (char === '\n' && !insideQuotes) {
        rows.push(parseCSVRow(currentRow))
        currentRow = ''
      } else {
        currentRow += char
      }
    }

    if (currentRow) {
      rows.push(parseCSVRow(currentRow))
    }

    return rows
  } catch (error) {
    console.error(`Parse Csv Error: ${error}`)
  }
}

const formatCSVValue = (csvValue) => {
  let newCsvValue = String(csvValue)

  newCsvValue = newCsvValue.replace(/"/g, '""')

  if (/[,\n"]/.test(newCsvValue)) {
    newCsvValue = `"${newCsvValue}"`
  }

  return newCsvValue
}

export const exportToImage = async (chart, format, exportFunc, fileName) => {
  try {
    let node = chart
    let bg = getComputedStyle(node).backgroundColor
    while (bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent') {
      node = node.parentNode
      if (!node) {
        break
      }
      ///1st elem should be Element instance
      if (node instanceof Element) {
        bg = getComputedStyle(node).backgroundColor
      }
    }

    const dataUrl = await exportFunc(chart, {
      filter,
      quality: 99,
      style: {
        position: 'initial',
        backgroundColor: bg,
      },
    })
    const link = document.createElement('a')
    document.body.appendChild(link)
    link.download = fileName || `widget.${format}`
    link.href = dataUrl
    link.click()
    link.remove()
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('oops, something went wrong!', err)
  }
}

export const exportToJpeg = (chart, fileName) => exportToImage(chart, 'jpeg', domtoimage.toJpeg, fileName)

export const exportToPng = (chart, fileName) => exportToImage(chart, 'png', domtoimage.toPng, fileName)

export const exportToPdf = async (chart, fileName) => {
  const width = chart.offsetWidth
  const height = chart.offsetHeight
  try {
    let node = chart
    let bg = getComputedStyle(node).backgroundColor
    while (bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent') {
      node = node.parentNode
      if (!node) {
        break
      }
      bg = getComputedStyle(node).backgroundColor
    }
    const dataUrl = await domtoimage.toPng(chart, {
      filter,
      quality: 99,
      style: {
        position: 'initial',
        backgroundColor: bg,
      },
    })
    // @ts-ignore
    const JsPDF = (await import('jspdf' /* webpackChunkName: "jspdf" */)).default
    const doc = new JsPDF({
      orientation: 'landscape',
      unit: 'px',
      format: [width, height],
    })
    const pdfWidth = doc.internal.pageSize.getWidth()
    const pdfHeight = doc.internal.pageSize.getHeight()
    doc.addImage(dataUrl, 'JPEG', 0, 0, pdfWidth, pdfHeight)
    doc.save(fileName || 'widget')
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('oops, something went wrong!', err)
  }
}

export const print = async (chart) => {
  try {
    printJS = (await import('print-js' /* webpackChunkName: "export" */)).default
    printJS({
      printable: chart.id,
      type: 'html',
      showModal: true,
    })
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('oops, something went wrong!', err)
  }
}

export const transformChartData = (data) => [['x', 'y'], ..._.map(data, (row) => [row.x, row.y])]

export const exportToCSV = async (chart, data) => {
  try {
    if (data && data.length && data.length > 0) {
      exportToCsv('widget.csv', data)
    }
  } catch (error) {
    console.error(error)
  }
}

export const options = [
  { key: 'Print', action: print, text: 'Print' },
  { key: 'JPEG', action: exportToJpeg, text: 'Save as JPEG' },
  { key: 'PNG', action: exportToPng, text: 'Save as PNG' },
  { key: 'PDF', action: exportToPdf, text: 'Save as PDF' },
  { key: 'CSV', action: exportToCSV, text: 'Save as CSV' },
]

export const styles = {
  button: {
    width: '50px',
    height: '50px',
  },
}

const ITEM_HEIGHT = 48
export const paperProps = {
  style: {
    maxHeight: ITEM_HEIGHT * 4.5,
    width: 150,
  },
}

const addKeyframe = (name, def) => {
  if (typeof document === 'undefined') {
    return
  }
  const head = document.getElementsByTagName('head')[0]
  let style = Array.from(head.getElementsByTagName('style')).find((node) => node.dataset[ANIMATIONS])
  if (!style) {
    style = document.createElement('style')
    style.type = 'text/css'
    style.dataset[ANIMATIONS] = true
    head.appendChild(style)
  }
  const content = style.textContent
  if (!content.includes(name)) {
    style.textContent += `\n@keyframes ${name} ${def}\n`
  }
}

const getLabelAnimationName = () => {
  const name = 'animation_label_opacity'
  addKeyframe(name, '{ 0% { opacity: 0; } 99% { opacity: 0; } 100% { opacity: 1; } }')
  return name
}
